export default "__VITE_ASSET__CUNynX9L__"